import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Youtube, Twitter, Phone, Mail, MapPin } from 'lucide-react';
import { siteData } from '../data/mock';

const Footer = () => {
  const { contact } = siteData;

  return (
    <footer className="bg-black border-t border-gray-800 pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <Link to="/" className="text-2xl font-bold text-white hover:text-yellow-400 transition-colors mb-4 block">
              <span className="text-yellow-400">ROMERO</span> SUMPTER
            </Link>
            <p className="text-gray-400 mb-6 max-w-md">
              Minister • Author • Master Clothier<br />
              Anointed to Inspire • Gifted to Create • Driven to Build
            </p>
            <div className="flex space-x-4">
              <a 
                href={contact.social.facebook} 
                className="text-gray-400 hover:text-yellow-400 transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a 
                href={contact.social.instagram} 
                className="text-gray-400 hover:text-yellow-400 transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a 
                href={contact.social.youtube} 
                className="text-gray-400 hover:text-yellow-400 transition-colors"
                aria-label="YouTube"
              >
                <Youtube size={20} />
              </a>
              <a 
                href={contact.social.twitter} 
                className="text-gray-400 hover:text-yellow-400 transition-colors"
                aria-label="Twitter"
              >
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 uppercase tracking-wider">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/ministry" className="text-gray-400 hover:text-lime-400 transition-colors">
                  Ministry
                </Link>
              </li>
              <li>
                <Link to="/books" className="text-gray-400 hover:text-lime-400 transition-colors">
                  Books
                </Link>
              </li>
              <li>
                <Link to="/clothier" className="text-gray-400 hover:text-lime-400 transition-colors">
                  Clothier
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-lime-400 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4 uppercase tracking-wider">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Mail size={18} className="text-yellow-400 flex-shrink-0" />
                <a href={`mailto:${contact.email}`} className="text-gray-400 hover:text-yellow-400 transition-colors text-sm">
                  {contact.email}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Business Hours */}
        <div className="border-t border-gray-800 pt-8 mb-8">
          <div className="text-center">
            <h4 className="text-yellow-400 font-semibold mb-2 uppercase tracking-wider text-sm">Availability</h4>
            <p className="text-gray-400 text-sm">{contact.businessHours.general}</p>
            <p className="text-gray-400 text-sm mt-2">Email: <a href={`mailto:${contact.email}`} className="text-yellow-400 hover:text-yellow-300 transition-colors">{contact.email}</a></p>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Romero Sumpter. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;